
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/SEO/SEOHead';

export default function PrivacyPolicyPage() {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead 
        title="سیاست حریم خصوصی | آریا گرین گلخانه"
        description="سیاست حریم خصوصی و حفاظت از اطلاعات شخصی کاربران در وب‌سایت آریا گرین گلخانه. اطلاعات کامل درباره نحوه جمع‌آوری، استفاده و حفاظت از داده‌های شما."
        keywords="سیاست حریم خصوصی, حفاظت اطلاعات, گلخانه, آریا گرین"
      />
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50">
        <Header />
        
        <main className="pt-24">
          {/* Hero Section */}
          <section className="relative py-20">
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-600/10 to-teal-600/10"></div>
            <div className="relative px-4 lg:px-8">
              <div className="text-center">
                <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-emerald-700 to-teal-600 bg-clip-text text-transparent mb-6">
                  سیاست حریم خصوصی
                </h1>
                <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
                  در آریا گرین گلخانه، حفاظت از حریم خصوصی و اطلاعات شخصی شما اولویت اصلی ما است
                </p>
              </div>
            </div>
          </section>

          {/* Privacy Content */}
          <section className="py-16">
            <div className="px-4 lg:px-8">
              <div className="max-w-4xl mx-auto">
                <div className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-xl border border-gray-200/30 overflow-hidden">
                  <div className="p-8 lg:p-12">
                    
                    {/* Introduction */}
                    <div className="mb-12">
                      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                        <div className="w-8 h-8 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center mr-3">
                          <i className="ri-shield-check-line text-white text-lg"></i>
                        </div>
                        مقدمه
                      </h2>
                      <p className="text-gray-700 leading-relaxed mb-4">
                        این سیاست حریم خصوصی نحوه جمع‌آوری، استفاده، محافظت و به اشتراک‌گذاری اطلاعات شما توسط شرکت آریا گرین گلخانه را توضیح می‌دهد. 
                        با استفاده از وب‌سایت ما، شما با این سیاست موافقت می‌کنید.
                      </p>
                    </div>

                    {/* Information Collection */}
                    <div className="mb-12">
                      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                        <div className="w-8 h-8 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center mr-3">
                          <i className="ri-information-line text-white text-lg"></i>
                        </div>
                        جمع‌آوری اطلاعات
                      </h2>
                      <div className="space-y-4">
                        <div className="bg-emerald-50/50 rounded-xl p-6">
                          <h3 className="text-lg font-semibold text-gray-800 mb-3">اطلاعات شخصی</h3>
                          <ul className="text-gray-700 space-y-2">
                            <li className="flex items-start">
                              <i className="ri-check-line text-emerald-600 mt-1 ml-2"></i>
                              نام و نام خانوادگی
                            </li>
                            <li className="flex items-start">
                              <i className="ri-check-line text-emerald-600 mt-1 ml-2"></i>
                              آدرس ایمیل
                            </li>
                            <li className="flex items-start">
                              <i className="ri-check-line text-emerald-600 mt-1 ml-2"></i>
                              شماره تلفن
                            </li>
                            <li className="flex items-start">
                              <i className="ri-check-line text-emerald-600 mt-1 ml-2"></i>
                              آدرس پستی (در صورت نیاز)
                            </li>
                          </ul>
                        </div>
                        <div className="bg-teal-50/50 rounded-xl p-6">
                          <h3 className="text-lg font-semibold text-gray-800 mb-3">اطلاعات غیر شخصی</h3>
                          <ul className="text-gray-700 space-y-2">
                            <li className="flex items-start">
                              <i className="ri-check-line text-teal-600 mt-1 ml-2"></i>
                              اطلاعات مرورگر و سیستم عامل
                            </li>
                            <li className="flex items-start">
                              <i className="ri-check-line text-teal-600 mt-1 ml-2"></i>
                              آدرس IP
                            </li>
                            <li className="flex items-start">
                              <i className="ri-check-line text-teal-600 mt-1 ml-2"></i>
                              صفحات بازدید شده
                            </li>
                            <li className="flex items-start">
                              <i className="ri-check-line text-teal-600 mt-1 ml-2"></i>
                              زمان و تاریخ بازدید
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Use of Information */}
                    <div className="mb-12">
                      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                        <div className="w-8 h-8 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center mr-3">
                          <i className="ri-focus-3-line text-white text-lg"></i>
                        </div>
                        استفاده از اطلاعات
                      </h2>
                      <div className="bg-gradient-to-r from-emerald-50/50 to-teal-50/50 rounded-xl p-6">
                        <p className="text-gray-700 mb-4">ما از اطلاعات جمع‌آوری شده برای موارد زیر استفاده می‌کنیم:</p>
                        <ul className="text-gray-700 space-y-3">
                          <li className="flex items-start">
                            <i className="ri-arrow-left-s-line text-emerald-600 mt-1 ml-2"></i>
                            ارائه خدمات و محصولات درخواستی
                          </li>
                          <li className="flex items-start">
                            <i className="ri-arrow-left-s-line text-emerald-600 mt-1 ml-2"></i>
                            پاسخ به سوالات و درخواست‌های شما
                          </li>
                          <li className="flex items-start">
                            <i className="ri-arrow-left-s-line text-emerald-600 mt-1 ml-2"></i>
                            ارسال اطلاعات محصولات و خدمات جدید
                          </li>
                          <li className="flex items-start">
                            <i className="ri-arrow-left-s-line text-emerald-600 mt-1 ml-2"></i>
                            بهبود کیفیت وب‌سایت و خدمات
                          </li>
                          <li className="flex items-start">
                            <i className="ri-arrow-left-s-line text-emerald-600 mt-1 ml-2"></i>
                            تحلیل رفتار کاربران برای بهینه‌سازی
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* Data Protection */}
                    <div className="mb-12">
                      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                        <div className="w-8 h-8 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center mr-3">
                          <i className="ri-shield-line text-white text-lg"></i>
                        </div>
                        حفاظت از داده‌ها
                      </h2>
                      <div className="bg-gradient-to-r from-emerald-50/50 to-teal-50/50 rounded-xl p-6">
                        <p className="text-gray-700 mb-4">
                          ما از روش‌های امنیتی پیشرفته برای محافظت از اطلاعات شما استفاده می‌کنیم:
                        </p>
                        <div className="grid md:grid-cols-2 gap-4">
                          <div className="bg-white/60 rounded-lg p-4">
                            <div className="flex items-center mb-2">
                              <i className="ri-lock-line text-emerald-600 text-lg ml-2"></i>
                              <span className="font-semibold text-gray-800">رمزگذاری SSL</span>
                            </div>
                            <p className="text-sm text-gray-600">تمام اطلاعات با پروتکل SSL امن منتقل می‌شوند</p>
                          </div>
                          <div className="bg-white/60 rounded-lg p-4">
                            <div className="flex items-center mb-2">
                              <i className="ri-database-2-line text-emerald-600 text-lg ml-2"></i>
                              <span className="font-semibold text-gray-800">ذخیره‌سازی امن</span>
                            </div>
                            <p className="text-sm text-gray-600">داده‌ها در سرورهای امن با دسترسی محدود نگهداری می‌شوند</p>
                          </div>
                          <div className="bg-white/60 rounded-lg p-4">
                            <div className="flex items-center mb-2">
                              <i className="ri-user-settings-line text-emerald-600 text-lg ml-2"></i>
                              <span className="font-semibold text-gray-800">کنترل دسترسی</span>
                            </div>
                            <p className="text-sm text-gray-600">فقط کارکنان مجاز به اطلاعات دسترسی دارند</p>
                          </div>
                          <div className="bg-white/60 rounded-lg p-4">
                            <div className="flex items-center mb-2">
                              <i className="ri-refresh-line text-emerald-600 text-lg ml-2"></i>
                              <span className="font-semibold text-gray-800">به‌روزرسانی منظم</span>
                            </div>
                            <p className="text-sm text-gray-600">سیستم‌های امنیتی مرتب به‌روزرسانی می‌شوند</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Cookies */}
                    <div className="mb-12">
                      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                        <div className="w-8 h-8 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center mr-3">
                          <i className="ri-fingerprint-line text-white text-lg"></i>
                        </div>
                        کوکی‌ها (Cookies)
                      </h2>
                      <div className="bg-gradient-to-r from-emerald-50/50 to-teal-50/50 rounded-xl p-6">
                        <p className="text-gray-700 mb-4">
                          وب‌سایت ما از کوکی‌ها برای بهبود تجربه کاربری استفاده می‌کند:
                        </p>
                        <div className="space-y-3">
                          <div className="flex items-start">
                            <i className="ri-settings-3-line text-emerald-600 mt-1 ml-2"></i>
                            <div>
                              <span className="font-semibold text-gray-800">کوکی‌های عملکردی:</span>
                              <span className="text-gray-700"> برای حفظ تنظیمات و ترجیحات شما</span>
                            </div>
                          </div>
                          <div className="flex items-start">
                            <i className="ri-bar-chart-line text-emerald-600 mt-1 ml-2"></i>
                            <div>
                              <span className="font-semibold text-gray-800">کوکی‌های تحلیلی:</span>
                              <span className="text-gray-700"> برای درک نحوه استفاده از سایت</span>
                            </div>
                          </div>
                          <div className="flex items-start">
                            <i className="ri-ads-line text-emerald-600 mt-1 ml-2"></i>
                            <div>
                              <span className="font-semibold text-gray-800">کوکی‌های بازاریابی:</span>
                              <span className="text-gray-700"> برای ارائه محتوای مرتبط (اختیاری)</span>
                            </div>
                          </div>
                        </div>
                        <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                          <p className="text-sm text-yellow-800">
                            <i className="ri-information-line ml-1"></i>
                            شما می‌توانید در تنظیمات مرورگر خود، کوکی‌ها را مدیریت یا غیرفعال کنید.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Third Party Services */}
                    <div className="mb-12">
                      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                        <div className="w-8 h-8 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center mr-3">
                          <i className="ri-links-line text-white text-lg"></i>
                        </div>
                        خدمات شخص ثالث
                      </h2>
                      <div className="bg-gradient-to-r from-emerald-50/50 to-teal-50/50 rounded-xl p-6">
                        <p className="text-gray-700 mb-4">
                          ما از برخی خدمات شخص ثالث برای بهبود عملکرد سایت استفاده می‌کنیم:
                        </p>
                        <ul className="text-gray-700 space-y-2">
                          <li className="flex items-start">
                            <i className="ri-google-line text-emerald-600 mt-1 ml-2"></i>
                            <span><strong>Google Analytics:</strong> برای تحلیل ترافیک سایت</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-map-pin-line text-emerald-600 mt-1 ml-2"></i>
                            <span><strong>Google Maps:</strong> برای نمایش موقعیت مکانی</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-message-2-line text-emerald-600 mt-1 ml-2"></i>
                            <span><strong>پلتفرم‌های پیام‌رسان:</strong> برای ارتباط سریع‌تر</span>
                          </li>
                        </ul>
                        <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                          <p className="text-sm text-blue-800">
                            <i className="ri-shield-check-line ml-1"></i>
                            این خدمات دارای سیاست حریم خصوصی مستقل هستند که توصیه می‌کنیم آن‌ها را مطالعه کنید.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* User Rights */}
                    <div className="mb-12">
                      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                        <div className="w-8 h-8 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center mr-3">
                          <i className="ri-user-heart-line text-white text-lg"></i>
                        </div>
                        حقوق شما
                      </h2>
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="bg-emerald-50/50 rounded-xl p-6">
                          <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                            <i className="ri-eye-line text-emerald-600 ml-2"></i>
                            دسترسی به اطلاعات
                          </h3>
                          <p className="text-gray-700 text-sm">
                            شما حق دارید از اطلاعات ذخیره شده خود آگاه شوید و درخواست مشاهده آن‌ها را داشته باشید.
                          </p>
                        </div>
                        <div className="bg-teal-50/50 rounded-xl p-6">
                          <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                            <i className="ri-edit-line text-teal-600 ml-2"></i>
                            اصلاح اطلاعات
                          </h3>
                          <p className="text-gray-700 text-sm">
                            در صورت وجود اشتباه در اطلاعات، می‌توانید درخواست اصلاح آن‌ها را ارائه دهید.
                          </p>
                        </div>
                        <div className="bg-cyan-50/50 rounded-xl p-6">
                          <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                            <i className="ri-delete-bin-line text-cyan-600 ml-2"></i>
                            حذف اطلاعات
                          </h3>
                          <p className="text-gray-700 text-sm">
                            شما می‌توانید درخواست حذف اطلاعات شخصی خود را ارائه دهید (با رعایت قوانین).
                          </p>
                        </div>
                        <div className="bg-blue-50/50 rounded-xl p-6">
                          <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                            <i className="ri-download-line text-blue-600 ml-2"></i>
                            انتقال اطلاعات
                          </h3>
                          <p className="text-gray-700 text-sm">
                            شما حق دارید کپی‌ای از اطلاعات خود را در قالب قابل خواندن دریافت کنید.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Policy Updates */}
                    <div className="mb-12">
                      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                        <div className="w-8 h-8 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center mr-3">
                          <i className="ri-refresh-line text-white text-lg"></i>
                        </div>
                        تغییرات در سیاست
                      </h2>
                      <div className="bg-gradient-to-r from-emerald-50/50 to-teal-50/50 rounded-xl p-6">
                        <p className="text-gray-700 mb-4">
                          ما ممکن است این سیاست حریم خصوصی را در صورت نیاز به‌روزرسانی کنیم. 
                          تغییرات مهم از طریق ایمیل یا اعلان در وب‌سایت به اطلاع شما خواهد رسید.
                        </p>
                        <div className="flex items-start p-4 bg-emerald-100 rounded-lg">
                          <i className="ri-calendar-line text-emerald-600 mt-1 ml-2"></i>
                          <div>
                            <span className="font-semibold text-gray-800">آخرین به‌روزرسانی:</span>
                            <span className="text-gray-700"> ۱۴۰۳/۱۰/۱۵</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Contact Information */}
                    <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl p-8 text-white">
                      <h2 className="text-2xl font-bold mb-4 flex items-center">
                        <i className="ri-customer-service-2-line text-2xl ml-3"></i>
                        تماس با ما
                      </h2>
                      <p className="mb-6">
                        اگر سوالی درباره این سیاست حریم خصوصی دارید یا نیاز به کمک در مورد اطلاعات شخصی‌تان دارید، 
                        با ما تماس بگیرید:
                      </p>
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="flex items-center">
                          <i className="ri-mail-line text-xl ml-3"></i>
                          <span>info@ariagreenhouse.com</span>
                        </div>
                        <div className="flex items-center">
                          <i className="ri-phone-line text-xl ml-3"></i>
                          <span>۰۲۱-۸۸۴۴۱۳۸۶</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </section>

        </main>

        <Footer />
      </div>
    </>
  );
}
